import type { EnemyDefinition, EnemyType } from './enemy.type';
import { enemies, bosses, getEnemyDefinition } from './enemy.type';
import type { EnvironmentType } from './environment.type';

let battleArray: Array<EnemyDefinition> = [];
export function createBattle(type?: EnemyType, level?: number) {
  if (!battleArray.length) {
    battleArray = [...enemies];
    //random sort battle Array
    battleArray.sort(() => Math.random() - 0.5);
  }

  var enemy: EnemyDefinition | undefined;
  if (type) {
    enemy = getEnemyDefinition(type);
  } else {
    enemy = battleArray.pop();
  }

  if (!enemy) {
    throw new Error('No enemies left');
  }

  let battle: Battle = {
    //Battle
    enemy: enemy,
    environment: enemy.environments[Math.floor(Math.random() * enemy.environments.length)],
    level: level || 0,
    type: 'normal',
    outcome: 'active',
  };
  return battle;
}

let bossArray: Array<EnemyDefinition> = [];
export function createBossBattle() {
  if (!bossArray.length) {
    bossArray = [...bosses];
    //random sort boss Array
    bossArray.sort(() => Math.random() - 0.5);
  }

  const boss = bossArray.pop();
  if (!boss) {
    throw new Error('No enemies left');
  }

  let battle: Battle = {
    //Battle
    enemy: boss,
    environment: boss.environments[Math.floor(Math.random() * boss.environments.length)],
    level: 1,
    type: 'boss',
    outcome: 'active',
  };
  return battle;
}

/** Where a fight is up to; the board and the tutorial both follow it. */
export enum BattleState {
  PreBattle = 'prebattle',
  Rolling = 'rolling',
  ActionPhase = 'actionPhase',
  Win = 'win',
  Lose = 'lose',
}

export type Battle = {
  enemy: EnemyDefinition;
  environment: EnvironmentType;
  level: number;
  type: 'normal' | 'boss';
  // modifiers?: Array<string>;
  outcome: 'active' | 'win' | 'lose';
  resolve?: Function;
};
